export default __webpack_public_path__ + "static/media/html.a92a549a.png";